<template>
    <li
        v-if="showItem && !item.hidden"
        :data-cy="`sidebar-item-${item.name}`"
        class="sidebar__item"
        :class="{'open-item' : itemIsExpanded}">
        <a
            class="sidebar__link"
            :class="{'active': item.active, 'disabled': item.disabled}"
            @click="itemClickEvent($event, {'index': index, 'item': item})">
            <i
                v-if="item.icon"
                class="sidebar__icon"
                :class="item.icon"/>
            <template v-if="!isCollapsed && !isCollapsing">
                <span class="sidebar__link__title">{{ item.title }}</span>
                <i
                    v-if="item.child"
                    class="sidebar__arrow-icon"
                    :class="itemIsExpanded ? arrowDownClass : arrowRightClass"/>
            </template>
        </a>
        <template v-if="item.child">
            <transition
                name="expand"
                @enter="expandEnter"
                @afterEnter="expandAfterEnter"
                @beforeLeave="expandBeforeLeave">
                <ul 
                    v-if="itemIsExpanded"
                    class="sidebar__dropdown">
                    <sub-item
                        :data-cy="`sidebar-item-${item.name}-${subItem.name}`"
                        v-for="(subItem, index) in item.child"
                        :key="index"
                        :projectRootFolder="projectRootFolder"
                        :item="subItem"
                        @subItemClick="subItemClickEvent($event)"/>
                </ul>
            </transition>
        </template>
    </li>
</template> 

<script>
import SubItem from './mag-sidebar-sub-item.vue'
import { animationMixin } from '../mixin';

export default {
    name: 'Item',
    components: {
        SubItem
    },
    computed: {
        itemIsExpanded(){
            if(this.expandedItems.includes(this.index)){
                return true;
            } else {
                return false;
            }
        }
    },
    data(){
        return {
            showItem: true
        }
    },
    watch: {
        item(val){
            this.analyseMenu(val)
        }
    },
    mixins: [animationMixin],
    props: {
        item: {
            type: Object,
            required: true
        },
        index: {
            type: Number
        },
        isCollapsed: {
            type: Boolean
        },
        isCollapsing: {
            type: Boolean
        },
        active: {
            type: Boolean
        },
        expandedItems: {
            type: Array
        },
        arrowDownClass: {
            type: String
        },
        arrowRightClass: {
            type: String
        },
        projectRootFolder: {
            type: String
        }
    },
    methods: {
        itemClickEvent(event, obj) {
            if(obj.item.child){
                event.preventDefault();
                this.$emit('itemClick', obj.index);
                return false;
            } else {
                this.$emit('itemClickWithLink', obj.item.href);
            }
            
        },
        subItemClickEvent(href){
            this.$emit('subItemClick', href); 
        },
        analyseMenu(item){
            if(item.child) {
                let numberOfItems = item.child.length;
                let numberOfHiddenItems = 0
                item.child.map((child) => {
                    if(child.hidden){
                        numberOfHiddenItems++
                    }
                })
                if(numberOfItems === numberOfHiddenItems){
                    this.showItem = false;
                } else {
                    this.showItem = true;
                }
            }
        }
    }
}
</script>
